import request from '@/utils/request'
const url = 'index.php/bazaar/api/bazaar/'

//岗位展示
export function GetItemByData(type){
    return request({
        url: url +'Category/GetItemByData',
        method: 'get',
        params: {type}
    })
}
